import React from "react";
import { Button } from "react-bootstrap";

// Bottom action bar. Two actions: "Add N selected" commits the checked
// new rows to the form and closes the modal; "Cancel" closes without
// committing. (Earlier "Discard search" link was redundant with Cancel —
// click outside the modal / Esc also close.)
//
// `addableCount` is checked-rows-minus-already-added; the button label
// reflects what will actually land on the form.
export default function ActionBar({ addableCount, onAddSelected, onCancel }) {
  return (
    <div className="d-flex gap-2 align-items-center justify-content-end p-3 m-0 border-top w-100 bg-body-secondary">
      <Button variant="outline-secondary" size="sm" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="primary" size="sm" onClick={onAddSelected} disabled={addableCount === 0}>
        <i className="fa-solid fa-circle-plus me-1" aria-hidden="true" />
        {addableCount > 0 ? `Add ${addableCount} selected` : "Add selected"}
      </Button>
    </div>
  );
}
